export default "__VITE_ASSET__vmXHj9pL__"